module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--de-b9f50221aedf2752f1b043e1aaa791fc.jpg";